var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.521495302,0.0910156895 L0.0912890099,0.520948661 C-0.0314318447,0.643669516 -0.029518602,0.838000312 0.0912890099,0.958807924 L8.33353865,9.20215085 C8.45516623,9.3235051 8.65059031,9.32295846 8.77139792,9.20187753 L9.20133089,8.77194456 C9.32432506,8.6492237 9.32241182,8.45489291 9.20160421,8.33408529 L0.959354565,0.0907423691 C0.898677438,0.0300652428 0.819687846,0 0.740698254,0 C0.661435341,0 0.581899108,0.0303385632 0.521495302,0.0910156895 L0.521495302,0.0910156895 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B3\\u30FC\\u30B9\\u8A73\\u7D307",
    transform: "translate(-797.000000, -3112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8A2D\\u554F\\uFF12",
    transform: "translate(275.000000, 2823.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(522.000000, 287.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 2.300000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-18-Copy-4",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-:-Plus",
    transform: "translate(8.000000, 9.000000) rotate(-315.000000) translate(-8.000000, -9.000000) translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-21"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.663778087,
    y1: 0.663778087,
    x2: 8.62911513,
    y2: 8.62911513,
    id: "Stroke-23",
    stroke: "#4A90E2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.62911513,
    y1: 0.663778087,
    x2: 0.663778087,
    y2: 8.62911513,
    id: "Stroke-25",
    stroke: "#4A90E2",
    strokeLinecap: "round"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.d58359764840352dcce10de1ea118eb7.svg";
export { ForwardRef as ReactComponent };